<template>
    <div class="receipt-divider">
        <div v-if="['-', '='].includes(delimiter)" class="divider-lines">
            <div class="divider-line"></div>
            <div v-if="['='].includes(delimiter)" class="divider-line"></div>
        </div>
        <div v-if="text" class="divider-text" :class="{ 'large': large }">{{ text }}</div>
        <div v-if="['-', '='].includes(delimiter)" class="divider-lines">
            <div class="divider-line"></div>
            <div v-if="['='].includes(delimiter)" class="divider-line"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        text: {
            type: String,
            default: null
        },
        delimiter: {
            type: String,
            default: '-'
        },
        large: {
            type: Boolean,
            default: false
        }
    },
};
</script>

<style lang="scss" scoped>
.receipt-divider {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 24px;
    line-height: 1;

    .divider-lines {
        width: 100%;

        .divider-line {
            width: 100%;
            border-bottom: 1.5px dashed;
            margin: 1.5px 0;
        }
    }

    .divider-text {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 0px 13px;
        flex: none;

        &.large {
            transform: scale(1, 1.7);
        }
    }
}
</style>
